<template>
  <div class="org_detail">
    <el-dialog :visible.sync="outerVisible" title="组织详情">
      <div class="left">
        <div class="master_div master_flex">
          <span class="span_one">组织LOGO</span>
          <div class="name_icon"></div>
          <div class="button" @click="openDetails(failed)">查看认证信息</div>
        </div>
        <div class="master_div">
          <span class="span_one">组织名称</span>
          <span class="span_two">{{detail_obj[1]}}</span>
        </div>
        <div class="master_div">
          <span class="span_one">组织负责人</span>
          <span class="span_two">{{detail_obj[2]}}</span>
        </div>
        <div class="master_div">
          <span class="span_one">负责人手机号</span>
          <span class="span_two">{{detail_obj[3]}}</span>
        </div>
        <div class="master_div">
          <span class="span_one">组织规模</span>
          <span class="span_two">{{detail_obj[4]}}</span>
        </div>
        <div class="master_div">
          <span class="span_one">组织创建时间</span>
          <span class="span_two">{{detail_obj[5]}}</span>
        </div>
        <div class="master_div">
          <span class="span_one">组织创建地点</span>
          <span class="span_two">{{detail_obj[6]}}</span>
        </div>
        <div class="master_div">
          <span class="span_one">组织标签</span>
          <span class="span_biaoqian" v-for="item in bq_array" :key="item">{{item.name}}</span>
        </div>
      </div>
      <div class="right">
        <div class="right_pop">
          <div class="title">启用功能</div>
          <div class="son_group">
            <span class="son" v-for="item in funcArray" :key="item">{{item.name}}</span>
          </div>
        </div>
        <div class="right_pop">
          <div class="title">付费记录</div>
          <div class="son_group">
            <div class="sons" v-for="item in payArray" :key="item">
              {{item.name}}
              <span>{{item.time}}</span>
            </div>
          </div>
        </div>
      </div>
      <renzheng ref="renzheng"></renzheng>
    </el-dialog>
    
  </div>
</template>
<script>
export default {
  components: {
    renzheng: () => import(/* webpackChunkName: "design" */ "./renz_msg")
  },
  data() {
    return {
      failed:3,//这个要避免0 1 2 显示原始的认证信息页面 根据后台状态码来定
      outerVisible: false,
      org_name: "加优科技有限公司",
      org_func: "担当审批",
      detail_obj: {},
      bq_array: [
        {
          name: "付费"
        },
        {
          name: "认证"
        },
        {
          name: "活跃"
        }
      ],
      funcArray: [
        {
          name: "担当办公"
        },
        {
          name: "担当云资产"
        },
        {
          name: "担当任务"
        },
        {
          name: "担当企业云盘"
        },
        {
          name: "担当考勤"
        },
        {
          name: "担当审批"
        }
      ],
      payArray: [
        {
          name: "担当企业云盘-铂金企业版",
          time: "有效期：2020年1月20日"
        },
        {
          name: "担当企业云盘-铂金企业版",
          time: "已过期：2019年1月20日"
        },
        {
          name: "担当云资产",
          time: "普通组织"
        }
      ]
    };
  },
  methods: {
    openDetails(failed) {
      this.$refs.renzheng.init(failed);
    },
    init(a) {
      this.outerVisible = true;
      this.detail_obj = a;
    }
  }
};
</script>
<style lang="scss" scoped>
.org_detail {
  /deep/.el-dialog {
    width: 740px;
    /deep/.el-dialog__header {
      text-align: left !important;
      padding: 12px 18px;
      border-bottom: 1px solid #f4f4f4;
      .el-dialog__title {
        font-size: 14px;
        color: #323232;
        font-weight: 400;
      }
    }
    /deep/.el-dialog__body {
      padding: 0px 20px 30px 20px;
      display: flex;

      .left {
        flex: 1;
        border-right: 1px solid #f4f4f4;
      }
      .right {
        flex: 1;
        .right_pop {
          margin-top: 10px;
          .title {
            font-size: 16px;
            color: #323232;
            font-weight: bold;
            text-align: left;
            padding-left: 30px;
            height: 40px;
          }
          .son_group {
            text-align: left;
            padding-left: 30px;
            .son {
              line-height: 40px;
              background-color: #f2f7fe;
              color: #2479ed;
              width: auto;
              padding: 7px 14px;
              border-radius: 4px;
              margin-right: 10px;
            }
            .sons {
              background-color: #f2f7fe;
              color: #2479ed;
              font-size: 11px;
              height: 25px;
              line-height: 25px;
              margin-top: 5px;
              border-radius: 4px;
              padding-left: 10px;
              position: relative;
              span {
                position: absolute;
                right: 10px;
              }
            }
          }
        }
      }
    }
    .master_flex {
      display: flex;
      .button {
        cursor: pointer;
        height: 30px;
        width: 100px;
        margin-left: 15px;
        border-radius: 4px;
        border: 1px solid #2479ed;
        color: #2479ed;
        text-align: center;
      }
    }
    .master_div {
      margin-top: 10px;
      line-height: 32px;
      text-align: left;
      padding-left: 20px;
      padding-right: 20px;
      .name_icon {
        width: 76px;
        height: 76px;
        background-color: #266eea;
        display: inline-block;
        border-radius: 4px;
      }
      .span_one {
        display: inline-block;
        width: 120px;
        font-size: 14px;
        font-weight: bold;
        color: #323232;
      }
      .span_two {
        height: auto;
        color: #323232;
        font-weight: 400;
        font-size: 14px;
      }
      .span_biaoqian {
        height: 25px;
        width: auto;
        padding: 3px 7px;
        background-color: #f2f7fe;
        color: #266eea;
        margin-right: 10px;
        border-radius: 4px;
      }
      .new_Icon {
        margin-left: 42px;
        flex: 1;
        color: #323232;
        font-size: 18px;
        font-weight: bold;
        position: relative;
        span {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
}
</style>